/**
 * 套餐/计划工具（用于充值页等）
 */
export function getPlanLabels(plan) {
  if (!plan) return { tag: '积分', name: '' };
  const tag = plan.tag || plan.productType || '积分';
  const name = plan.name || plan.productName || '';
  return { tag, name };
}

export function isCreditsPlan(plan) {
  if (!plan) return false;
  const t = (plan.productType || plan.type || '').toLowerCase();
  return t === 'credits' || t === '积分' || t === 'credit';
}

export function isMembershipPlan(plan) {
  if (!plan) return false;
  const t = (plan.productType || plan.type || '').toLowerCase();
  return t === 'membership' || t === '会员' || t === 'member';
}
